import { Logo } from "components/Logo";
import { Logos, LogoSize } from "components/Logo/Logo";
import { BrandTextStyle } from "styles/TextStyles";

import { UserProfile, UserProfileProps } from "./components/UserProfile";
import { HeaderLogoStyle, HeaderTitleStyle } from "./HeaderStyle";

export type HeaderProps = {
    appTitle?: string;
    userProfile?: UserProfileProps;
    username?: string;
};

export const Header = ({ appTitle, userProfile, username }: HeaderProps) => {
    return (
        <div className="aevi-header" style={{ zIndex: 1000 }}>
            <HeaderLogoStyle>
                <Logo size={LogoSize.SMALL} src={Logos.AeviLogoBrand} className="aevi-header-image" />
            </HeaderLogoStyle>
            <HeaderTitleStyle>
                <BrandTextStyle>{appTitle ? `EPMS Portal - ${appTitle}` : "EPMS Portal"}</BrandTextStyle>
            </HeaderTitleStyle>
            <div className="aevi-header-right">
                <div className="aevi-header-username">{username}</div>
                {userProfile !== undefined && <UserProfile apps={userProfile.apps} />}
            </div>
        </div>
    );
};
